import ApplicationController from '../application_controller'
import bootbox from 'bootbox'

const RELATED_UNIT_IDS_SELECTOR = '#employee_related_unit_ids'
class PersonalNumberInputController extends ApplicationController {
  static targets = ['template', 'input', 'withoutTemplate']
  static values = { url: String, placeholder: String, currentNumber: String }

  connect () {
    this.originPersonalNumber = this.inputTarget.value

    $(() => {
      this._bindUnitChangeEvent()
      this._bindTemplateChangeEvent()
      this._bindPersonalNumberChangeEvent()
      this._bindFormSubmitEvent()

      const storedTemplate = this.templateTarget.value
      this._showOnlyMatchedTemplates()

      if (this.hasWithoutTemplateTarget && storedTemplate !== this.templateTarget.value) { this.unmatchedTemplateWarning() }
      if (this.hasWithoutTemplateTarget && this.withoutTemplateTarget.value.length === 0) { this.unmatchedTemplateWarning() }

      if (this.availableUnitIDs.length > 0 && this.personalNumber === null) {
        this.templateTarget.dispatchEvent(new Event('change')) // Generate PNR
      }
      if (document.querySelector('#personal_number_taken_alert')) {
        document.getElementById('get-new-pn').classList.remove('hidden')
      }
    })
  }

  unmatchedTemplateWarning () {
    const wrapperDiv = this.inputTarget.closest('div')
    wrapperDiv.classList.remove('has-success')
    wrapperDiv.classList.add('has-error')
    document.getElementById('pn-warning').style.display = 'block'
    document.getElementById('get-new-pn').classList.remove('hidden')
  }

  removeUnmatchedWarning () {
    const wrapperDiv = this.inputTarget.closest('div')
    wrapperDiv.classList.remove('has-error')
    document.getElementById('pn-warning').classList.add('hidden')
  }

  getNewPersonalNumber () {
    this.templateTarget.dispatchEvent(new Event('change'))
  }

  enableTemplateSelector () {
    this.templateTarget.removeAttribute('disabled')
  }

  disableTemplateSelector () {
    this.templateTarget.disabled = true
  }

  enableManualInput () {
    this.inputTarget.removeAttribute('readonly')
  }

  disableManualInput () {
    this.inputTarget.readOnly = true
  }

  enterLoadingState () {
    this.inputTarget.classList.add('loading')
  }

  exitLoadingState () {
    this.inputTarget.classList.remove('loading')
  }

  async _fetchNextPersonalNumber () {
    const params = new URLSearchParams({
      unit_id: this.selectedTemplateOption.dataset.unitId,
      personal_number_template_id: this.selectedTemplateID
    })

    this.enterLoadingState()

    return await fetch(`${this.urlValue}?${params}`, {
      contentType: 'application/json'
    }).then(data => {
      return data.json()
    }).then(jsonData => {
      return jsonData.personal_number
    }).catch(() => {
      // @TODO: make the appropriate translation key
      $.growlyflash({
        msg: I18n.t('career_sites.update.settings_error'),
        type: 'danger'
      })

      return 0
    }).finally(() => {
      this.exitLoadingState()
    })
  }

  _updatePersonalNumber (template, personalNumber) {
    const escapedTemplate = template.replaceAll(/9|a/g, '\\$&')
    const mask = escapedTemplate.replace(this.placeholderValue, '9{1,}')
    $(this.inputTarget).inputmask({ mask, keepStatic: true })
    this.inputTarget.value = personalNumber

    this.removeUnmatchedWarning()
  }

  get availableUnitsSelector () {
    return this.inputTarget.form.querySelector(RELATED_UNIT_IDS_SELECTOR)
  }

  get availableUnitIDs () {
    const jqSelector = $(this.availableUnitsSelector)

    if (jqSelector.data('select2')) {
      return jqSelector.select2('data').map(opt => opt.id)
    }

    return jqSelector.val()
  }

  get selectedTemplateID () {
    if (this.selectedTemplateOption && this.selectedTemplateOption !== '') {
      return this.selectedTemplateOption.value
    } else {
      return null
    }
  }

  get selectedTemplate () {
    if (this.selectedTemplateOption) {
      return this.selectedTemplateOption.dataset.template || this.placeholderValue
    } else {
      return this.placeholderValue
    }
  }

  get selectedTemplateOption () {
    return this.templateTarget.selectedOptions[0]
  }

  get personalNumber () {
    if (this.inputTarget.value === '' || this.inputTarget.value == null) return null

    return this.inputTarget.value
  }

  get templateOptions () {
    return this.templateTarget.querySelectorAll('option')
  }

  get matchedTemplateOptions () {
    let ids = this.availableUnitIDs
    if (!Array.isArray(ids)) {
      ids = [ids]
    }
    const result = []

    for (const templateOption of this.templateOptions) {
      if (ids.indexOf(templateOption.dataset.unitId) !== -1) result.push(templateOption)
    }

    return result
  }

  _showOnlyMatchedTemplates () {
    for (const template of this.templateOptions) template.hidden = true
    for (const template of this.matchedTemplateOptions) template.removeAttribute('hidden')

    const blankOption = this.templateOptions[0]
    if (this.matchedTemplateOptions.length === 0) blankOption.hidden = false
    const simpleOption = this.matchedTemplateOptions.find(option => option.dataset.template === '{n}' && option.hidden === false)
    if (this.selectedTemplateOption?.hidden) (simpleOption || this.matchedTemplateOptions[0] || blankOption).selected = true
  }

  _bindUnitChangeEvent () {
    $(this.availableUnitsSelector).on('change', () => {
      const selectedOption = this.templateTarget.querySelector('option:checked')
      this._showOnlyMatchedTemplates()
      const matchedOption = this.templateTarget.querySelector('option:checked')
      if (selectedOption !== matchedOption) this.templateTarget.dispatchEvent(new Event('change'))
    })
  }

  _bindTemplateChangeEvent () {
    this.templateTarget.addEventListener('change', async () => {
      const nextPersonalNumber = await this._fetchNextPersonalNumber()
      this.disableManualInput()

      this._updatePersonalNumber(this.selectedTemplate, nextPersonalNumber)
    })
  }

  _bindPersonalNumberChangeEvent () {
    this.inputTarget.addEventListener('change', () => {
      this._updatePersonalNumber(this.selectedTemplate, this.inputTarget.value)
    })
  }

  _bindFormSubmitEvent () {
    const submitButtonOriginal = this.inputTarget.form.querySelector('[type="submit"]').cloneNode()

    this.inputTarget.form.addEventListener('submit', (e) => {
      if (this.currentNumberValue === '' || this.currentNumberValue == null) return
      if (this.currentNumberValue === this.personalNumber) return

      e.preventDefault()

      const message = I18n.t('employees.alerts.personal_number_update_confirmation_html', {
        old_value: this.currentNumberValue,
        new_value: this.personalNumber || I18n.t('none')
      })

      bootbox.confirm({
        title: I18n.t('layouts.common.sure'),
        message: `<div class="text-center"><i class="fa fa-exclamation-triangle"></i> ${message}</div>`,
        buttons: {
          cancel: { label: `<i class="fa fa-times"></i> ${I18n.t('back')}` },
          confirm: { label: `<i class="fa fa-check"></i> ${I18n.t('confirm')}` }
        },
        callback: (result) => {
          if (result) {
            this.inputTarget.form.submit()
          } else {
            this.inputTarget.form.querySelector('[type="submit"]').replaceWith(submitButtonOriginal.cloneNode())
          }
        }
      })
    })
  }
}

export default PersonalNumberInputController
